import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.RETURN_TRACKING.SOLICITATIONS.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.RETURN_TRACKING.SOLICITATIONS.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.RETURN_TRACKING.SOLICITATIONS.BASE_URL;
}

const getAllSolicitations = sapCode => {
  return axios.get(`${BASE_URL}/trackings?sapcode=${sapCode}`);
};

export default {
  getAllSolicitations
};
